<style>
  .Warning {
    background-color: #ff9595 !important;
  }

  .TdTitle {
    background: #17b88b;
    color: white;
    font-weight: bold;
  }

  .AfterTr {
    background-color: #489b39;
    color: white;
  }

  .BeforeTr {
    background-color: #9b3939;
    color: white;
  }
</style>

<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت اطلاعات گواهی نامه</h5>

    <div *ngIf="!Showing_Form_Nominal_Value">

      <app-DataEntityDeviceInfo 
        [inner_calibration_id]="Calibration_Device_Id"
        (outter_Calibration_Device)="Set_CalibrationDeviceInfo_click($event)">
        
      </app-DataEntityDeviceInfo>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Certificate Code </label>
            <input value="{{CertificateCode}}" disabled type="text" class="form-control">
          </div>

          <div class="form-group col-md-4">
              <app-DataEntityLabAddress
              [inner_Calibration_Device_Id]="Calibration_Device_Id"
              [inner_Calibration_Lab_Address]="Calibration_Device.labAdderss"
              (outter_selected_Lab_Address)="Set_LabAddress_click($event)">

            </app-DataEntityLabAddress>
          </div>

          <div class="form-group col-md-4">
            <app-DataEntityLinearity
            [inner_Calibration_Device_Id]="Calibration_Device_Id"
            [inner_Calibration_Display]="Calibration_Device.display_linearity">

          </app-DataEntityLinearity>
        </div>

        </div>
      </form>

      <br />
      <hr />
      <br />

      <app-DataEntityCertificateNote [inner_Calibration_Device_Id]="Calibration_Device_Id">

      </app-DataEntityCertificateNote>

      <br />
      <hr />
      <br />

      <app-AddressLetterCertificate [inner_Calibration_Detail_Id]="Calibration_Device_Id">

      </app-AddressLetterCertificate>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> واحد Nominal Value </label>
            <select class="custom-select" (change)="OnUserSetUnit(1,templateUnit)" [(ngModel)]="unit_nomimal" name="unit_nomimal">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> واحد Reference value (Average) </label>
            <select class="custom-select" (change)="OnUserSetUnit(2,templateUnit)" [(ngModel)]="unit_reference" name="unit_reference">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> واحد Correction </label>
            <select class="custom-select" (change)="OnUserSetUnit(3,templateUnit)" [(ngModel)]="unit_correction" name="unit_correction">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> واحد Correction from Line Equation </label>
            <select class="custom-select" (change)="OnUserSetUnit(4,templateUnit)" [(ngModel)]="unit_correction_eqution" name="unit_correction_eqution">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> واحد Uncertainty </label>
            <select class="custom-select" (change)="OnUserSetUnit(5,templateUnit)" [(ngModel)]="unit_uncertainy" name="unit_uncertainy">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>
          <div class="form-group col-md-4" style="display: none;">
            <label for="exampleInputEmail1"> واحد Correction Factor (Z) </label>
            <select class="custom-select" (change)="OnUserSetUnit(6,templateUnit)" [(ngModel)]="unit_zfactor" name="unit_zfactor">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />


      <form>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> MANUFACTURE </label>
            <input [(ngModel)]="Manufacture_txt" name="Manufacture_txt" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> TYPE 1</label>
            <select class="custom-select" [(ngModel)]="Type_txt" name="Type_txt">
              <option value="">انتخاب کنید</option>
              <option value="IN">IN</option>
              <option value="EX">EX</option>

            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> TYPE 2</label>
            <select class="custom-select" [(ngModel)]="Model_txt" name="Model_txt">
              <option value="">انتخاب کنید</option>
              <option value="A">A</option>
              <option value="AS">AS</option>
              <option value="B">B</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> DELIVERY TIME (second) </label>
            <input [(ngModel)]="DELIVERY_TIME" name="DELIVERY_TIME" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>

        </div>
      </form>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> بارگذاری فایل : </label>
            <input type="file" #file_excel>
          </div>
          <div class="form-group col-md-6">
            <img *ngIf="Procssing_Import" src="assets/Loading.gif" style="width: 25px;" />
            <button *ngIf="!Procssing_Import" type="button" class="btn btn-warning"
              (click)="upload_file_excel(file_excel.files)"> بارگذاری فایل <i class="fa fa-upload"></i></button>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> بارگذاری فایل پیوست : </label>
            <input type="file" #file_pdf>
          </div>
          <div class="form-group col-md-6">
            <img *ngIf="Procssing_Import2" src="assets/Loading.gif" style="width: 25px;" />
            <button *ngIf="!Procssing_Import2" type="button" class="btn btn-info"
              (click)="upload_file_pdf(file_pdf.files)"> بارگذاری فایل پیوست <i class="fa fa-upload"></i></button>
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />

    </div>



    <div [hidden]="Nominal_Value_List.length==0 || !Showing_Form_Nominal_Value">

      <h4>ویرایش Nominal Value</h4>
      <br />
      <br />

      <form [formGroup]="MainFormDataEntity">

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Water © before </label>
            <input (keyup)="Calc_Main_Function()" formControlName="Temperature_Water_before" type="number"
              class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Temperature_Water_before().valid && get_Form_Temperature_Water_before().touched"
              class="form-text text-muted MyErrorRedColor">Temperature of Water © before را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Water © after </label>
            <input formControlName="Temperature_Water_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Temperature_Water_after().valid && get_Form_Temperature_Water_after().touched"
              class="form-text text-muted MyErrorRedColor">Temperature of Water © after را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Air © before </label>
            <input (keyup)="Calc_Main_Function()" formControlName="Temperature_Air_before" type="number"
              class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Temperature_Air_before().valid && get_Form_Temperature_Air_before().touched"
              class="form-text text-muted MyErrorRedColor">Tmperature of Air © before را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Air © after </label>
            <input (keyup)="Calc_Main_Function()" formControlName="Temperature_Air_after" type="number"
              class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Temperature_Air_after().valid && get_Form_Temperature_Air_after().touched"
              class="form-text text-muted MyErrorRedColor">Tmperature of Air © after را وارد نمائید.</small>
          </div>
        </div>

        <div class="row">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Humidity of Air (%rH) before </label>
            <input (keyup)="Calc_Main_Function()" formControlName="Humidity_Air_before" type="number"
              class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Humidity_Air_before().valid && get_Form_Humidity_Air_before().touched"
              class="form-text text-muted MyErrorRedColor">Humidity of Air (%rH) before را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Humidity of Air (%rH) after </label>
            <input formControlName="Humidity_Air_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Humidity_Air_after().valid && get_Form_Humidity_Air_after().touched"
              class="form-text text-muted MyErrorRedColor">Humidity of Air (%rH) after را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Ambient Pressure (hPa) before </label>
            <input (keyup)="Calc_Main_Function()" formControlName="Pressure_before" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Pressure_before().valid && get_Form_Pressure_before().touched"
              class="form-text text-muted MyErrorRedColor">Ambient Pressure (hPa) before را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Ambient Pressure (hPa) after </label>
            <input formControlName="Pressure_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Pressure_after().valid && get_Form_Pressure_after().touched"
              class="form-text text-muted MyErrorRedColor">Ambient Pressure (hPa) after را وارد نمائید.</small>
          </div>

        </div>

        <div class="row">

          <div class="form-group col-md-3" [ngClass]="{'Warning': get_Form_Reference_Temperature().value==27 }">
            <label for="exampleInputEmail1"> Reference Temperature </label>
            <select formControlName="Reference_Temperature" class="custom-select">
              <option value="20">20</option>
              <option value="27">27</option>
            </select>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Device </label>
            <input formControlName="Temperature_Device" disabled type="number" class="form-control" value="0">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> &#x3C1;A (g/ml) </label>
            <input formControlName="PA_Device" disabled type="number" class="form-control" value="0">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> &#x3C1;w (g/ml) </label>
            <input formControlName="PW_Device" disabled type="number" class="form-control" value="0">
          </div>

        </div>

        <br />
        <hr />
        <br />

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Min Rage </label>
            <input formControlName="range_min" type="text" class="form-control EnglishClm"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Max Rage </label>
            <input formControlName="range_max" type="text" class="form-control EnglishClm"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> SCALE DIVISION </label>
            <input formControlName="scale" type="text" class="form-control EnglishClm"
              placeholder="اینجا تایپ کنید ...">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Nominal Value (Unit- Volume) </label>
            <input formControlName="Nominal_Value" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Nominal_Value().valid && get_Form_Nominal_Value().touched"
              class="form-text text-muted MyErrorRedColor">Nominal Value را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> &#x3C1;B (g/ml) </label>
            <input formControlName="y_A" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_y_A().valid && get_Form_y_A().touched"
              class="form-text text-muted MyErrorRedColor">&#x3C1;A (g/ml) را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> &#x3B3; </label>
            <input formControlName="y" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_y().valid && get_Form_y().touched"
              class="form-text text-muted MyErrorRedColor">&#x3B3; را وارد نمائید.</small>
          </div>
        </div>
      </form>


      <form [formGroup]="DetailFormDataEntity">
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Mesured Mass (Unit - Mass) </label>
            <input formControlName="Mesured_Mass" (keyup.enter)="Add_Mesured_Mass_List()" type="number"
              class="form-control" placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-8">
            <button type="button" (click)="Add_Mesured_Mass_List()" class="btn btn-warning" style="margin-left: 5px;"><i
                class="fa  fa-plus-circle"></i> افزودن Mesured Mass </button>

          </div>
        </div>
      </form>

      <div class="table-responsive" *ngIf="Mesured_Mass_List.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Mesured Mass (Unit - Mass)</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Mesured_Mass_List">

              <td>{{Mesured_Mass_List.indexOf(item)+1}}</td>
              <td>
                <input type="text" style="width: 70px;" name="measure_{{Mesured_Mass_List.indexOf(item)}}"
                  [(ngModel)]="item.title">
              </td>

              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;" (click)="Delete_Mesured_Mass_List(Mesured_Mass_List.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                    </div>
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>


      <br />
      <hr />
      <br />

    </div>

    <div class="table-responsive" *ngIf="Nominal_Value_List.length>0 && !Showing_Form_Nominal_Value">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">

        <ng-container *ngFor="let item of Nominal_Value_List">

          <tr>
            <td class="TdTitle">Temperature of Water © before</td>
            <td> {{item.temperature_Water_before}} </td>

            <td class="TdTitle">Temperature of Water © after</td>
            <td> {{item.temperature_Water_after}} </td>

            <td class="TdTitle">Temperature of Air © before</td>
            <td> {{item.temperature_Air_before}} </td>

            <td class="TdTitle">Temperature of Air © after</td>
            <td> {{item.temperature_Air_after}} </td>
          </tr>

          <tr>
            <td class="TdTitle">Humidity of Air (%rH) before</td>
            <td> {{item.humidity_Air_before}} </td>

            <td class="TdTitle">Humidity of Air (%rH) after</td>
            <td> {{item.humidity_Air_after}} </td>

            <td class="TdTitle">Ambient Pressure (hPa) before</td>
            <td> {{item.pressure_before}} </td>

            <td class="TdTitle">Ambient Pressure (hPa) after</td>
            <td> {{item.pressure_after}} </td>

          </tr>

          <tr>
            <td class="TdTitle">Reference Temperature</td>
            <td> {{item.reference_Temperature}} </td>

            <td class="TdTitle">Temperature of Device</td>
            <td> {{item.Temperature_Device}} </td>

            <td class="TdTitle">&#x3C1;A (g/ml)</td>
            <td> {{item.PA}} </td>

            <td class="TdTitle">&#x3C1;w (g/ml)</td>
            <td> {{item.PW}} </td>
          </tr>

          <tr>
            <td colspan="8">

              <table class="mb-0 table table-bordered table-3 text-center table-striped">

                <thead [ngClass]="{'BeforeTr': item.before==true,'AfterTr': item.before==false }">
                  <tr>
                    <th>#</th>
                    <th>Nominal Value (Unit- Volume)</th>
                    <th>Average</th>
                    <!--
                  <th>SD</th>
                  <th>CV</th>
                  <th>&#x3C1;B (g/ml)</th>
                  <th>&#x3B3; (g/ml)</th>
                  <th>Reference Value (Unit- Volume)</th>
                -->
                    <th>Converge Factor</th>
                    <th>Value</th>
                    <th>Z Factor</th>
                    <th>uncertainty</th>
                    <th>امکانات</th>
                  </tr>
                </thead>

                <tbody>
                  <ng-container>

                    <tr [ngClass]="{'Warning': item.error>MPE_RND && item.sd>item.mpe_rnd }">

                      <td>{{Nominal_Value_List.indexOf(item)+1}}</td>
                      <td>{{item.nominal}}</td>
                      <td>{{item.average}}</td>
                      <!--
                    <td>{{item.sd}}</td>
                    <td>{{item.cv}}</td>
                    <td>{{item.yb}}</td>
                    <td>{{item.y}}</td>
                    <td>{{item.reference_Value}}</td>
                  -->
                      <td>{{item.converage}}</td>
                      <td>{{item.value}}</td>
                      <td>{{item.zFactor}}</td>
                      <td> {{item.uncertainty}} </td>
                      <td>
                        <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                          <div class="btn-group" role="group">
                            <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              امکانات
                            </button>
                            <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                              <a style="cursor: pointer;"
                                (click)="Edit_Nominal_Value_List(Nominal_Value_List.indexOf(item))"
                                class="dropdown-item"><i class="fa fa-edit"></i> ویرایش </a>

                              <a style="cursor: pointer;"
                                *ngIf="Nominal_Value_List.indexOf(item)==0 && item.before==false"
                                (click)="Copy_After_As_Before()" class="dropdown-item"><i
                                  class="fa fa-arrow-circle-down"></i> کپی به عنوان Before </a>

                              <a style="cursor: pointer;" *ngIf="!item.mesured_visible"
                                (click)="Visible_Nominal_Value_List(Nominal_Value_List.indexOf(item))"
                                class="dropdown-item"><i class="fa fa-eye"></i> مشاهده جزئیات </a>
                              <a style="cursor: pointer;" *ngIf="item.mesured_visible"
                                (click)="Visible_Nominal_Value_List(Nominal_Value_List.indexOf(item))"
                                class="dropdown-item"><i class="fa fa-eye-slash"></i> عدم مشاهده جزئیات </a>

                              <a style="cursor: pointer;" *ngIf="Nominal_Value_List.indexOf(item)>0"
                                (click)="Copy_From_Up(Nominal_Value_List.indexOf(item))" class="dropdown-item"><i
                                  class="fa fa-arrow-circle-up"></i> کپی محیط از بالا </a>

                              <a style="cursor: pointer;"
                                *ngIf="Nominal_Value_List.indexOf(item)<(Nominal_Value_List.length-1)"
                                (click)="Copy_From_Down(Nominal_Value_List.indexOf(item))" class="dropdown-item"><i
                                  class="fa fa-arrow-circle-down"></i> کپی محیط از پایین </a>

                            </div>
                          </div>
                        </div>
                      </td>

                    </tr>

                    <tr *ngIf="item.mesured_visible">
                      <td colspan="8">
                        <table class="mb-0 table table-bordered table-3 text-center table-striped">
                          <thead style="background-color: #39649b; color: white;">
                            <tr>
                              <th>#</th>
                              <th>Mesured Mass (Unit - Mass)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let itemdetail of item.mesured; let j = index">
                              <td>{{j+1}}</td>
                              <td>{{itemdetail}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>

                  </ng-container>
                </tbody>

              </table>

            </td>
          </tr>

        </ng-container>

      </table>
    </div>

    <div *ngIf="Showing_Form_Nominal_Value">
      <div class="row">
        <div class="form-group col-md-8">
          <button type="button" [disabled]="!MainFormDataEntity.valid" (click)="Add_Nominal_Value(templateAfter,0)"
            class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ویرایش Nominal
            Value</button>

          <button *ngIf="!InProccessing" (click)="Cancel_Nominal_Value_List()" type="button" class="btn btn-danger"
            style="margin-left: 5px;"><i class="fa fa-times-rectangle"></i> لغو </button>
        </div>
      </div>
    </div>

    <div *ngIf="!Showing_Form_Nominal_Value">

      <br />
      <hr />
      <br />
      <button *ngIf="InProccessing" type="button" class="btn btn-info" style="margin-left: 5px;"> سیستم در حال ساخت
        گواهی نامه می باشد. لطفا صبر نمائید ... <i class="fa fa-spin fa-spinner"></i> </button>

      <button *ngIf="!InProccessing && !CertificateCode" type="button" (click)="onSubmit(templateCode)"
        class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات گواهی نامه
      </button>
      <button *ngIf="!InProccessing && CertificateCode" type="button" (click)="onSubmit(templateCode)"
        class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-edit"></i>
        ویرایش
        اطلاعات گواهی نامه </button>

      <a target="_blank" *ngIf="!InProccessing && CertificateCode && CertificateUrlPdf" href="{{CertificateUrlPdf}}"
        style="margin-left: 5px;" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> فایل گواهی نامه </a>

      <button routerLink="/KartableInbox" *ngIf="!InProccessing" type="button" style="margin-left: 5px;"
        class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>

    </div>

  </div>
</div>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> کد گواهی نامه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>کد گواهی نامه فرم کالبیراسیون کد گواهی نامه <b>'{{CertificateCode}}'</b></p>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateAfter>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> هشدار </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_After.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <h6> مقدار Nominal Value در Range نمی باشد </h6>
    <h6> آیا مقدار Nominal Value را تایید می نمائید؟ </h6>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="Confirm_Nominal_Value(1)">بله، مورد تایید است</button>
    <button type="button" class="btn btn-danger" (click)="Confirm_Nominal_Value(0)">خیر</button>
  </div>
</ng-template>

<ng-template #templateUnit>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> آیا واحد انتخاب شده  به واحد های تعیین  نشده، اعمال شود؟ </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Unit.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="SetToAllUnit()"> بله اعمال شود <i class="fa fa-check"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Unit.hide()">بستن</button>
  </div>
</ng-template>